var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconObjetivosInclusao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#98004B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 7.5C15.038 7.5 15.6739 7.76339 16.1428 8.23223C16.6116 8.70107 16.875 9.33696 16.875 10C16.875 10.663 16.6116 11.2989 16.1428 11.7678C15.6739 12.2366 15.038 12.5 14.375 12.5C13.712 12.5 13.0761 12.2366 12.6072 11.7678C12.1384 11.2989 11.875 10.663 11.875 10C11.875 9.33696 12.1384 8.70107 12.6072 8.23223C13.0761 7.76339 13.712 7.5 14.375 7.5ZM12.5 32.5V25H8.75L12 15.5C12.375 14.5 13.25 13.75 14.375 13.75C15.5 13.75 16.5 14.5 16.75 15.5L20 25L23.25 15.5C23.625 14.5 24.5 13.75 25.625 13.75C26.75 13.75 27.75 14.5 28 15.5L31.25 25H27.5V32.5H23.75V25H16.25V32.5H12.5ZM25.625 7.5C26.288 7.5 26.9239 7.76339 27.3928 8.23223C27.8616 8.70107 28.125 9.33696 28.125 10C28.125 10.663 27.8616 11.2989 27.3928 11.7678C26.9239 12.2366 26.288 12.5 25.625 12.5C24.962 12.5 24.3261 12.2366 23.8572 11.7678C23.3884 11.2989 23.125 10.663 23.125 10C23.125 9.33696 23.3884 8.70107 23.8572 8.23223C24.3261 7.76339 24.962 7.5 25.625 7.5Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconObjetivosInclusao);
export default __webpack_public_path__ + "static/media/icon-objetivos-inclusao.c6820d3c67376694e2d7df22dff540c1.svg";
export { ForwardRef as ReactComponent };